
<template>
  <div>
    <a type="button" class="text-dark text-decoration-none d-flex justify-content-center text-center" data-bs-toggle="modal" data-bs-target="#adventureModal">
      <span>Included Sports &amp; Activities</span>
      <!-- <span class="glyphicon glyphicon-question-sign"></span> -->
    </a>
    <div
      id="adventureModal"
      class="modal"
      tabindex="-1"
      aria-labelledby="adventureModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg"> 
        <div class="modal-content p-4">
          <h2 class="text-center">Sports &amp; Activities</h2>
          <div>
          <h6 class="text-center">Our policies cover you for all the activities listed below at no extra cost!</h6>
        </div>

        <div class="my-5">
          <ul>
            <li>Abseiling/Rap Jumping (supervised only)</li>
            <li>Aerobics</li>
            <li>Archery</li>
            <li>Athletics</li>
            <li>Backpacking</li>
            <li>Baseball/Rounders/Softball</li>
            <li>Battle Re-enactment (no live ammunition)</li>
            <li>Banana Boating/Tubing</li>
            <li>Basketball</li>
            <li>Boogie Boarding</li>
            <li>Bouldering</li>
            <li>Bowls</li>
            <li>Breathing Observation/Bubble Diving</li>
            <li>Bridge Walking</li>
            <li>Bungy Jumping (maximum 2 jumps)</li>
            <li>Canoeing/Kayaking (freshwater/sea)</li>
            <li>Canyoning/Kloofing</li>
            <li>Cricket</li>
            <li>Cross country skiing/Langlaufen</li>
            <li>Curling</li>
            <li>Cycling (cycles not covered)</li>
            <li>Dog Sledding</li>
            <li>Drag Hunting</li>
            <li>Dragon Boating</li>
            <li>Dune/Wadi Bashing</li>
            <li>Falconry</li>
            <li>Fell/Gorge Walking (on recognised routes)</li>
            <li>Fencing</li>
            <li>Field Hockey</li>
            <li>Fishing (coarse/fly/deep sea)</li>
            <li>Football (Soccer)</li>
            <li>Go Karting</li>
            <li>Golf</li>
            <li>Gorge Swinging</li>
            <li>Gymnastics</li>
            <li>Guided Glacier Walking</li>
            <li>Helicopter rides (as passenger only)</li>
            <li>Hot Air Ballooning (as passenger only)</li>
            <li>Horse Riding or riding other animals</li>
            <li>Hurling</li>
            <li>Hydro Speeding</li>
            <li>Jet Boating</li>
            <li>Jet Skiing</li>
            <li>Marathon Running</li>
            <li>Mountain Boarding</li>
            <li>Mountain Biking</li>
            <li>Netball</li>
            <li>Non-Manual Work</li>
            <li>Orienteering</li>
            <li>Outward Bound Pursuits</li>
            <li>Overland Travel</li>
            <li>Paintballing</li>
            <li>Parascending/Parasailing</li>
            <li>Racquet Sports</li>
            <li>Roller Blading/Ice Skating</li>
            <li>Rowing</li>
            <li>Running/Jogging</li>
            <li>Safari/Gorilla Trekking</li>
            <li>Safari Travel (in a vehicle,horseback or on foot)</li>
            <li>Sailing</li>
            <li>Scuba Diving(up to 40 metres in depth - excludes solo diving)</li>
            <li>Shooting</li>
            <li>Snow Shoeing (guided)</li>
            <li>Snorkelling</li>
            <li>Surfing (surf board excluded from policy)</li>
            <li>Swimming (excluding long distance in open water)</li>
            <li>Table Tennis</li>
            <li>Tall Ship Crewing</li>
            <li>Trampolining</li>
            <li>Trekking/Rambling/Hiking (recognised routes under 7000 metres only)</li>
            <li>Tree canopy walks</li>
            <li>Triathlon</li>
            <li>Tug of War</li>
            <li>Tubing</li>
            <li>Via Ferrata</li>
            <li>Volleyball</li>
            <li>Volunteering (as defined)</li>
            <li>Wall Climbing (man-made climbing walls)</li>
            <li>Wake Boarding/Water Skiing</li>
            <li>Water Polo</li>
            <li>White/Black Water Rafting or Canoeing</li>
            <li>Windsurfing (boards not covered)</li>
            <li>Zip Lining</li>
            <li>Zorbing</li>
          </ul>
        </div>
        <div class="text-center">
           <button type="button" class="btn btn-outline-secondary mb-5" data-bs-dismiss="modal">Cancel</button>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

export default {
  props : ["quote"],
  data() {
    return {
      modalShow:false,
      showBackpackerInfo : false
    }
  },
  methods: {
    hideModal() {
      this.modalShow = false
    },
  },
  watch: {
    quote(value) {
      if(value === 'BACKPACKER'){
        this.showBackpackerInfo = true
      }else {
        this.showBackpackerInfo = false
      }
    }
  }
 
}
</script>
<style scoped>
</style>